import { defaultIconProps, IconProps } from './IconProps';

export const IconStackLeft: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M0.999999 1L1 13M7.66667 3L3.66667 7M3.66667 7L7.66667 11M3.66667 7L13 7" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

IconStackLeft.defaultProps = defaultIconProps;
